const LEGACY_BUNDLE_PATH = '/assets/index-D6mQ7Yeu.js';

export async function loadLegacyApp(): Promise<void> {
  const root = document.getElementById('root');
  if (!root) {
    throw new Error('Elemento #root non trovato: impossibile montare il bundle legacy.');
  }

  window.dispatchEvent(new CustomEvent('im:legacy-loading'));
  await import(/* @vite-ignore */ LEGACY_BUNDLE_PATH);
  window.dispatchEvent(new CustomEvent('im:legacy-loaded'));
}
